import { render, staticRenderFns } from "./clientFollowUp.vue?vue&type=template&id=f25e9dac&scoped=true&"
import script from "./clientFollowUp.vue?vue&type=script&lang=js&"
export * from "./clientFollowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25e9dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f25e9dac')) {
      api.createRecord('f25e9dac', component.options)
    } else {
      api.reload('f25e9dac', component.options)
    }
    module.hot.accept("./clientFollowUp.vue?vue&type=template&id=f25e9dac&scoped=true&", function () {
      api.rerender('f25e9dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/clientFollowUp/clientFollowUp.vue"
export default component.exports